import { FormRegistration } from '@/components/form-registration-v2';
import { HeaderMenu } from '@/components/header-menu';
import { useAuth } from '@/store/useAuth';
import { Spiner } from '@/ui-kit';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './registrationV2.module.scss'
import clsx from 'clsx';
import { LangSelector } from '@/components/lang-selector/lang-selector';
import { BackBtn } from '@/components/back-btn';
import WebApp from '@twa-dev/sdk';

export const RegistrationV2 = () => {
    const [isLoadingOnce, setIsLoadingOnce] = useState(true);
    const userData = useAuth((state) => state.getUser());
    const { stepNumer } = useParams();
    return userData ? (
        <>
            <HeaderMenu append={<LangSelector />}>
                <div
                    className={styles.progress}>
                    <div className={styles.progressbar}>
                        {
                            Array
                                .from({ length: WebApp.initData.length ? 8 : 7 })
                                .map(
                                    (_, index) =>
                                        <div
                                            className={
                                                clsx(
                                                    styles['progressbar-item'],
                                                    index + 1 <= parseInt(stepNumer ?? '0') && styles['progressbar-item--active']
                                                )
                                            } />
                                )
                        }
                    </div>
                </div>
            </HeaderMenu>
            <FormRegistration
                step={stepNumer}
                isLoadingOncePage={isLoadingOnce}
                onChangeIsLoadingPage={setIsLoadingOnce} />
        </>
    ) : (
        <Spiner />
    );
};
